type ProjectsIconProps = {
  className?: string;
  fill?: string;
};

const ProjectsIcon = ({ className, fill = "#212121" }: ProjectsIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24 7.18164L15.0034 1.83594L11.023 4.19918L12.981 5.36261L15.003 4.16212L22 8.31968V15.6784L15.003 19.8359L12.981 18.6355L11.023 19.7989L15.0034 22.1621L24 16.8164V7.18164Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00336 1.83594L18 7.18163V16.8164L9.00336 22.1621L0 16.8167V7.1814L9.00336 1.83594ZM2 8.31991V15.6782L9.00296 19.8359L16 15.6784V8.31968L9.00296 4.16212L2 8.31991Z"
      fill={fill}
    />
  </svg>
);

export default ProjectsIcon;
